import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { safeStorage } from "@/lib/safeStorage";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!safeStorage.getItem("bv_cookie_accepted")) {
      setTimeout(() => setShow(true), 1500);
    }
  }, []);
  const accept = () => {
    safeStorage.setItem("bv_cookie_accepted", "1");
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-[60] glass-strong rounded-xl p-4 border border-white/10 shadow-2xl animate-fade-up" data-testid="cookie-banner">
      <p className="text-sm text-white/85 mb-3">
        🍪 A jobb élmény érdekében sütiket használunk. Részletek az <Link to="/cookie-iranyelvek" className="text-gold underline">Cookie irányelvekben</Link>.
      </p>
      <div className="flex gap-2">
        <button onClick={accept} className="gold-btn rounded-md px-4 py-2 text-sm" data-testid="cookie-accept">Elfogadom</button>
        <Link to="/cookie-iranyelvek" className="px-4 py-2 text-sm text-white/70 hover:text-white">Beállítások</Link>
      </div>
    </div>
  );
}
